import { useMemo } from 'react';
import { SubsFeature, SubsProductName } from '@thndr/namespace/subscriptions';
import { MarketName } from '::root/libs/namespace/subscriptions/src/types';

export const usePlanCard = ({ market }: { market?: MarketName } = {}) => {
  const PRODUCT_INFO = useMemo<{
    [product in SubsProductName]?: {
      name: string;
      icon: string;
      announcement?: string;
      featureDescription?: string;
      features: SubsFeature[];
    };
  }>(() => {
    if (market === MarketName.ADX) {
      return {
        TRADER: {
          name: 'products.TRADER.name',
          icon: '/icons/trader.png',
          features: [
            {
              name: 'features.realTime.title',
            },
            {
              name: 'features.customPrice.title',
            },
            {
              name: 'features.phoneCallSupport.title',
            },
            {
              name: 'features.priceDepth.title',
            },
          ],
        },
      };
    } else {
      const traderFeatures: SubsFeature[] = [
        {
          name: 'features.thndrX.title',
          subtitle: 'features.thndrX.subtitle',
          platforms: ['platforms.thndrx'],
        },
        {
          name: 'features.freeTrades.title',
          subtitle: 'features.freeTrades.subtitle',
          platforms: ['platforms.web', 'platforms.app', 'platforms.thndrx'],
        },
        {
          name: 'features.realTimeData.title',
          subtitle: 'features.realTimeData.subtitle',
          platforms: ['platforms.web', 'platforms.app', 'platforms.thndrx'],
        },
        {
          name: 'features.customPriceAlerts.title',
          subtitle: 'features.customPriceAlerts.subtitle',
          platforms: ['platforms.app'],
        },
        {
          name: 'features.fastChat.title',
          subtitle: 'features.fastChat.subtitle',
          platforms: ['platforms.app'],
        },
        {
          name: 'features.marketDepth.title',
          subtitle: 'features.marketDepth.subtitle',
          platforms: ['platforms.web', 'platforms.app', 'platforms.thndrx'],
        },
        {
          name: 'features.tradesBook.title',
          subtitle: 'features.tradesBook.subtitle',
          platforms: ['platforms.app', 'platforms.thndrx'],
        },
      ];

      return {
        SPARK: {
          name: 'products.SPARK.name',
          icon: '/icons/spark.png',
          featureDescription: 'products.SPARK.featureDescription',
          announcement: 'products.SPARK.announcement',
          features: [
            {
              name: 'features.fastChat.title',
              subtitle: 'features.fastChat.subtitle',
              platforms: ['platforms.app'],
            },
            {
              name: 'features.customPriceAlerts.title',
              subtitle: 'features.customPriceAlerts.subtitle',
              platforms: ['platforms.app'],
            },
            {
              name: 'features.inAppCandlesticks.title',
              subtitle: 'features.inAppCandlesticks.subtitle',
              platforms: ['platforms.app'],
            },
            {
              name: 'features.customThemes.title',
              subtitle: 'features.customThemes.subtitle',
              platforms: ['platforms.app'],
            },
          ],
        },
        EG_EXPRESS: {
          name: 'products.EG_EXPRESS.name',
          icon: '/icons/express.png',
          featureDescription: 'products.EG_EXPRESS.featureDescription',
          announcement: 'products.EG_EXPRESS.announcement',
          features: [
            {
              name: 'features.realTimeData.title',
              subtitle: 'features.realTimeData.subtitle',
              platforms: ['platforms.web', 'platforms.app'],
            },
            {
              name: 'features.sameDaySettlement.title',
              subtitle: 'features.sameDaySettlement.subtitle',
              platforms: ['platforms.web', 'platforms.app'],
            },
            {
              name: 'features.advancedLimitOrders.title',
              subtitle: 'features.advancedLimitOrders.subtitle',
              platforms: ['platforms.app'],
            },
            {
              name: 'features.stopLoss.title',
              subtitle: 'features.stopLoss.subtitle',
              platforms: ['platforms.app'],
            },
            {
              name: 'features.marketDepth.title',
              subtitle: 'features.marketDepth.subtitle',
              platforms: ['platforms.web', 'platforms.app'],
            },
            {
              name: 'features.tradesBook.title',
              subtitle: 'features.tradesBook.subtitle',
              platforms: ['platforms.app'],
            },
            {
              name: 'features.subscriptionInCapitalIncrease.title',
              subtitle: 'features.subscriptionInCapitalIncrease.subtitle',
              platforms: ['platforms.web', 'platforms.app'],
            },
          ],
        },
        TRADER: {
          name: 'products.TRADER.name',
          icon: '/icons/trader.png',
          featureDescription: 'products.TRADER.featureDescription',
          announcement: 'products.TRADER.announcement',
          features: traderFeatures,
        },
        EG_RACER: {
          name: 'products.EG_RACER.name',
          icon: '/icons/express.png',
          featureDescription: 'products.EG_RACER.featureDescription',
          features: [],
        },
      };
    }
  }, [market]);

  return { PRODUCT_INFO };
};
